import { getLocalizedDocumentTagOptions } from 'ComponentLibrary/src/molecules/SelectTags/constants'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

export function useDocumentTagOptions() {
    const currentLocale = useCurrentResolvedLocale()

    return getLocalizedDocumentTagOptions(currentLocale)
}
